import type {
  GroupToRoleMapping,
  SamlIdentityProvider,
} from '@repo/api-gw-sdk';

import { UpsertGroupMappingStep } from './upsertGroupMappingStep';

import type { Step } from '../wizard/Step';

export interface UpsertGroupMappingState {
  editMode: boolean;
  groupMapping: GroupToRoleMapping;
  saml: SamlIdentityProvider | undefined;
}

export const upsertGroupMappingFlow: Step<UpsertGroupMappingState> = {
  name: 'Upsert Group Mapping',
  Component: UpsertGroupMappingStep,
};
